import { MetaTags } from '@redwoodjs/web'
import { NavLink, useParams } from '@redwoodjs/router'

import { ButtonLink } from 'src/components/Button'
import ChangeOrdersCell from "src/components/ChangeOrdersCell"
import { ChangeOrderState, OrderType } from 'types/graphql'
import { startCase } from 'lodash'
import { useChangeType, useChangeRoutes } from 'src/components/hooks'

const OrderStateFilters: Record<string, ChangeOrderState[]> = {
  'in-progress': ['Draft', 'Review'],
  complete: ['Complete'],
  cancelled: ['Cancelled']
}

const RequestStateFilter: Record<string, ChangeOrderState[]> = {
  'open': ['Draft', 'Review'],
  closed: ['Complete', 'Cancelled'],
}

function getStateFilter(type: OrderType) {
  return type === 'ChangeOrder' ? OrderStateFilters : RequestStateFilter
}

function isStateFilter(filter: string, filters: Record<string, ChangeOrderState[]>): boolean {
  return (filter in filters);
}

const ChangeOrdersPage = () => {
  const orgId = useParams().orgId!
  const state = useParams().state!
  const { upperLabel, type } = useChangeType()
  const changeRoutes = useChangeRoutes()
  const filters = getStateFilter(type)
  const filter = isStateFilter(state, filters) ? state : 'draft';

  return (
    <>
      <MetaTags
        title={`Change ${upperLabel}`}
        description={`Change ${upperLabel} page`}
      />
      <div className='max-w-[1200px] mx-auto px-6 pb-12 pt-6'>
        <div className=''>
          <div className='flex pt-4 pb-8'>
            <nav className='flex gap-2 *:inline-block *:text-gray-700'>
              {Object.entries(filters).map(([state]) =>
                <li key={state}>
                  <NavLink
                    className='pr-2 pl-2 align-middle'
                    activeClassName='pr-2 pl-2 align-middle font-semibold'
                    to={changeRoutes.list({state, orgId})}>{startCase(state)}
                    </NavLink>
                </li>
              )}
            </nav>
            <div className='ml-auto'>
              <ButtonLink writeOnly={type === 'ChangeOrder'} variant='primary' to={changeRoutes.create({ orgId })}>
                Create Change {upperLabel}
              </ButtonLink>
            </div>
          </div>
            <ChangeOrdersCell filter={filters[filter]!} type={type}/>
        </div>
      </div>
  </>)
}

export default ChangeOrdersPage
